import { trpc } from '@/shared/api/trpc';

export const useTaskCollectionById = (id: string | undefined) =>
  trpc.taskCollections.byId.useQuery(
    { id: id ?? '' },
    { enabled: Boolean(id) }
  );
